import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {MemberLink} from '../models/member-link';
import {map} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MemberLinksService {

  constructor (private db: AngularFirestore) { }

  select () {
    return this.db.collection<any>('sbccv_member_links', ref => ref
      .orderBy('date', 'asc')).snapshotChanges();
  }

  load () {
    return this.db.collection<any>('sbccv_member_links', ref => ref
      .orderBy('date', 'asc')).get();
  }

  loadByName () {
    return this.db.collection<any>('sbccv_member_links', ref => ref
      .orderBy('member_name', 'asc')
      .orderBy('date', 'asc')).get();
  }

  selectByMemberId (memberId: string) {
    return this.db.collection<MemberLink>('sbccv_member_links', ref => ref
      .where("member_id", "==", memberId)
      .orderBy('date', 'asc'))
      .snapshotChanges()
      .pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as any;
          const id = a.payload.doc.id;
          return {
            ...data,
            id,
            // Tratamento seguro de datas
            date: data.date?.toDate() || null
          } as MemberLink;
        }))
      );
  }

  insert (entity: MemberLink) {
    return this.db.collection('sbccv_member_links').add(Object.assign({}, entity));
  }

  update (entity: MemberLink) {
    return this.db.collection('sbccv_member_links')
      .doc(entity.id)
      .set(Object.assign({}, entity), {'merge': true});
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_member_links').doc(entity_id).delete();
  }

  createLink (data) {
    const entity = new MemberLink()
    entity.id = data.id;
    entity.member_id = data.member_id;
    entity.member_name = data.member_name;
    entity.date = data.date;
    entity.text = data.text;
    entity.link = data.link;
    return entity
  }

}


